<div class="innerpage-fullwithbanner">
    <h2 class="bighead">Property import</h2>
    <ul class="bread-crumbs">
        <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
        <li>Property import</li>
    </ul>
</div>

<div class="featuredproperties section-margin">
    <div class="container container-lg min-heightcontainer">
        <div class="border-div  margin0">
           <div class="form-group">
               <div class="form-radio">
                   <label class="radio radio-inline">
                       <input type="radio" checked (change)="onTemplateChange(false)" name="radio1"/>B+E Listing
                       <i class="helper"></i>
                   </label>
                   <label class="radio radio-inline">
                       <input type="radio" name="radio1" (change)="onTemplateChange(true)" />1031 Listing
                       <i class="helper"></i>
                   </label>
               </div>
           </div>
            <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                    <div class="clearfix">
                        <div class="form-group bulkuploadform">
                            <input type="file" class="bulkuploadinput"  #file (change)="onFileChange($event)" />
                            <input type="text" readonly class="form-control" [(ngModel)]="fileName" />
                            <button class="browsebtn">Browse</button>
                        </div>
                        <button class="btn btn-success  validatebtn" *ngIf="stage!=2" (click)="onValidateClick()">Validate</button>
                        <button class="btn btn-success  validatebtn" *ngIf="stage==2" (click)="onValidateClick()">Re-Validate</button>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 downloadlink">
                    <p *ngIf="!canShow1031Template">Don't have a template?  <a href="{{excelDownloadPath}}/BEListing.xlsx">Click here</a> to download</p>
                    <p *ngIf="canShow1031Template">Don't have a template?  <a href="{{excelDownloadPath}}/1031Listing.xlsx">Click here</a> to download</p>
                </div>
            </div>
            <!--<a href="#">-->
                <div class="importinprogressdiv" *ngIf="stage==1" >
                    <i class="icofont icofont-hour-glass icon"></i>
                    <h6>Import in progress</h6>
                </div>
            <!--</a>-->
            <div class="importinprogressdiv" *ngIf="stage==4">
                <i class="icofont icofont-hour-glass icon"></i>
                <h6>Validation in progress</h6>
            </div>
            <div class="errordata" *ngIf="stage==2">
                <h4><i class="icofont icofont-warning icon"></i>Validated {{importPropertyResponse.TotalRecordCount}} Records from "{{fileName}}". Found {{importPropertyResponse.ErrorCount}} errors</h4>
                <div class="table-responsive">
                    <table class="table basictable">
                        <thead>
                            <tr>
                                <th>Row</th>
                                <th>Error</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of importPropertyResponse.ErrorList">
                                <td>{{item.RowNumber}}</td>
                                <td>{{item.ErrorMessage}}</td>
                            </tr>                            
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="successdiv" *ngIf="stage==3">
                <i class="icofont icofont-check-alt icon"></i>
                <h2>Done</h2>
                <h6>Validated {{importPropertyResponse.TotalRecordCount}} Records from "{{fileName}}". Found No errors</h6>
                <button class="btn btn-lg btn-success" (click)="onImportClick()">Import</button>
            </div>
        </div>
    </div>
</div>

